import { where } from "firebase/firestore"
import moment from "moment"
import { Collection, WhereField } from '../../shared/constants'
import { deleteDoc, getAllDocsByQueries, getAllDocsByRevendaId, getDocById, updateDoc } from './collectionBaseWorker'

export const getNewSubscriptionById = async ({ id }) => {
    return await getDocById({ collection: Collection.NEW_SUBSCRIPTIONS_CLIENTS, id: id })
}

export const geAllNewSubscriptionPendingByParkId = async ({ estacionamentoId }) => {
    return await getAllDocsByQueries({
        collection: Collection.NEW_SUBSCRIPTIONS_CLIENTS,
        queries: [
            where(WhereField.PARKSIDS, "array-contains", estacionamentoId),
            where(WhereField.STATUS, "==", "GENERATED")
        ]
    })
}

export const geAllNewSubscriptionPendingByClientId = async ({ clienteId }) => {
    return await getAllDocsByQueries({
        collection: Collection.NEW_SUBSCRIPTIONS_CLIENTS,
        queries: [
            where(WhereField.CLIENTEID, "==", clienteId),
            where(WhereField.STATUS, "==", "PENDING")
        ]
    })
}

export const geAllNewSubscriptionByParkId = async ({ estacionamentoId }) => {
    return await getAllDocsByQueries({
        collection: Collection.NEW_SUBSCRIPTIONS_CLIENTS,
        queries: [
            where(WhereField.PARKSIDS, "array-contains", estacionamentoId)
        ]
    })
}

export const geAllPendingSubscriptionByParkId = async ({ estacionamentoId }) => {
    const pending = await geAllNewSubscriptionByParkId({ estacionamentoId: estacionamentoId })
    return pending.filter(e => e.status !== "PAYED" && e.status !== "CANCELED")
}

export const getAllSubscriptionByRevendaId = async ({ revendaId }) => {
    return await getAllDocsByRevendaId({ collection: Collection.NEW_SUBSCRIPTIONS_CLIENTS, revendaId: revendaId })
}

export const getPendingSubscriptionByStartDateRevendaId = async ({ startDate, revendaId }) => {
    const items = await getAllDocsByQueries({
        collection: Collection.NEW_SUBSCRIPTIONS_CLIENTS,
        queries: [
            where(WhereField.CHANGE_DATE, ">=", startDate)
        ]
    })
    return items.filter(e => e.revendaId === revendaId && e.status !== "PAYED" && e.status !== "CANCELED")
}

export const updateNewSubscriptionById = async ({ id, data }) => {
    await updateDoc({ collection: Collection.NEW_SUBSCRIPTIONS_CLIENTS, id: id, data: data })
}

export const deleteNewSubscriptionItem = async ({ id }) => {
    await deleteDoc({ collection: Collection.NEW_SUBSCRIPTIONS_CLIENTS, id: id })
}

export const getAllSubscriptionByRevendaByMonth = async ({ associatedResales, date }) => {
    const month = date.format("M");
    const year = date.format("Y");
    const docs = await getAllDocsByQueries({
        collection: Collection.NEW_SUBSCRIPTIONS_CLIENTS,
        queries: [
            where(WhereField.REVENDAID, "in", associatedResales.map(e => e.value)),
            where(WhereField.MONTH, "==", parseInt(month)),
            where(WhereField.YEAR, "==", parseInt(year))
        ]
    })
    return transformNewSubscriptionStatus({ result: docs })
}

export const getAllSubscriptionByYearByRevendaIds = async ({ associatedResales }) => {
    const year = moment().startOf('year').format("Y")
    const docs = await getAllDocsByQueries({
        collection: Collection.NEW_SUBSCRIPTIONS_CLIENTS,
        queries: [
            where(WhereField.REVENDAID, "in", associatedResales.map(e => e.value)),
            where(WhereField.YEAR, "==", parseInt(year))
        ]
    })
    return docs
}

export const transformNewSubscriptionStatus = ({ result }) => {
    return result.filter(e => e.status !== "CANCELED").map(data => {
        const dateString = `${data.day}/${data.month}/${data.year}`
        const changeDate = moment(dateString, "DD/MM/YYYY")
        if (data.status !== "CANCELED") {
            if (data.status !== "PAYED" && moment().isAfter(changeDate)) {
                data.status = "PENDING"
            } else if (data.status !== "PAYED") {
                data.status = "GENERATED"
            }
        }
        if (!data.warnings) {
            data.warnings = []
        }
        if (data.plan.quantidadeMensagensMes === undefined) {
            data.plan.quantidadeMensagensMes = 20
        }
        return data
    }).sort((a, b) => -b.status.localeCompare(a.status))
}